module.exports = __webpack_public_path__ + "media/images/lp_v6_img04-84fd5c10f6dc223343736df5a6e15a4f.webp";